export default __webpack_public_path__ + "static/media/hot-13.06b356b5.png";